import shop from '../../api/orderTransaction';
import { sendSuccessNotice, sendErrorNotice, getCurrentTime } from '@/commons/utils';
import { request_list } from '@/commons/hpod';
import _ from "lodash";
import Vue from 'vue';
const endpoint = 'order_transactions'

// initial state
const state = {
    loading: false,
    edited: false,
    all: {},
    orderCodes: [],
    transCodes: [],
    selected: {}
};

// getters
const getters = {};

// actions
const actions = {
    getList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list(endpoint, data => {
            commit('setList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getOrderTransactionList({ commit }, param) {
        shop.getOrderTransactionList(data => {
            commit('setOrderTransactionList', data);
        }, Vue.http, param, this.state.authentication.token);
    },
    putOrderTransaction({ commit, dispatch }, param) {
        commit('setEdited', {edited: false});
        shop.putOrderTransaction(item => {
            if(item.status == 204) {
                sendErrorNotice('Mã vận đơn đã tồn tại.')
            }
            else{
                sendSuccessNotice('Đã thêm mới mã vận đơn.')
                shop.getOrderTransactionList(data => {
                    commit('setOrderTransactionList', data);
                    if(param.PackageType == 1) {
                        dispatch("deposit/getDetail", param.OrderID, {root:true});
                    }
                    else {
                        dispatch("main_order/getOrderDetail", param.OrderID, {root:true});
                    }
                }, Vue.http, { order_id: param.OrderID, package_type: param.PackageType }, this.state.authentication.token);
            }
        }, Vue.http, param, this.state.authentication.token);
    },
    deleteOrderTransaction({ commit }, param) {
        commit('setEdited', {edited: false});
        shop.deleteOrderTransaction(data => {
            commit('deleteOrderTransactionList', {type: param.type, idx: param.idx});
            sendSuccessNotice('Đã xóa mã vận đơn.')
        }, Vue.http, param, this.state.authentication.token);
    },
    postOrderTransaction({ commit, dispatch }, param) {
        commit('setEdited', {edited: false});
        let packageId = param.PackageId;
        delete param.PackageId;
        let filterTransaction = param.FilterTransaction;
        delete param.FilterTransaction;
        shop.postOrderTransaction(data => {
            commit('setEdited', {edited: true});
            if(data.status == 204) {
                sendErrorNotice('Mã vận đơn đã tồn tại.')
                shop.getOrderTransactionList(data => {
                    commit('setOrderTransactionList', data);
                    if(param.PackageType == 1) {
                        dispatch("deposit/getDetail", param.OrderID, {root:true});
                    }
                    else {
                        dispatch("main_order/getOrderDetail", param.OrderID, {root:true});
                    }
                }, Vue.http, { order_id: param.OrderID, package_type: param.PackageType }, this.state.authentication.token);
            }
            else {
                sendSuccessNotice('Cập nhật dữ liệu thành công.')
                if(param.PackageType == 1) {
                    dispatch("deposit/getDetail", param.OrderID, {root:true});
                }
                else {
                    if(packageId){
                        dispatch("bigPackageVn/getDetail", {'packageId': packageId, 'trancode': filterTransaction ? filterTransaction : ''}, {root:true});
                    }
                    else {
                        dispatch("main_order/getOrderDetail", param.OrderID, {root:true});
                    }
                }
            }
        }, Vue.http, param, this.state.authentication.token);
    },
};

// mutations
const mutations = {
    setList(state, data) {
        state.all = data;
    },
    setOrderTransactionList(state, res) {
        state.orderCodes = res.data.order_codes;
        state.transCodes = res.data.order_transactions;
    },
    updateOrderTransactionList(state, {type, res}) {
        if(type === "order_code"){
            state.orderCodes.push(res.data);
        }
        else {
            state.transCodes.push(res.data);
        }
        state.edited = true;
    },
    deleteOrderTransactionList(state, {type, idx}) {
        if(type === "order_code"){
            state.orderCodes.splice(idx, 1);
        }
        else {
            state.transCodes.splice(idx, 1);
        }
        state.edited = true;
    },
    setEdited(state, { edited }) {
        state.edited = edited;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
